"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectLogForHook = exports.objectLogDeserialize = void 0;
const moment_1 = __importDefault(require("moment"));
const User_1 = require("../controllers/User");
const expect_1 = __importDefault(require("../util/expect"));
const unwrap_1 = __importDefault(require("../util/unwrap"));
const BaseUser_1 = require("./BaseUser");
const deserializeNumber_1 = require("./deserializeNumber");
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
const AuthType_1 = require("./firebase/AuthType");
function objectLogDeserialize(value, id) {
    const object = (0, deserializeObject_1.default)(value, 'log');
    return {
        id: (0, deserializeString_1.deserializeString)(id),
        timestampMs: (0, deserializeNumber_1.deserializeNumber)(object.timestampMs),
        modifierAuthType: (0, AuthType_1.authTypeDeserialize)(object.modifierAuthType),
        modifierCasualName: (0, unwrap_1.default)(object.modifierCasualName, deserializeString_1.deserializeString),
        modifierId: (0, unwrap_1.default)(object.modifierId, deserializeString_1.deserializeString),
        object: object.object,
        objectId: (0, deserializeString_1.deserializeString)(object.objectId),
    };
}
exports.objectLogDeserialize = objectLogDeserialize;
const objectLogForHook = async function (object, objectId, context, database) {
    var _a, _b;
    return {
        timestampMs: (0, moment_1.default)(context.timestamp).valueOf(),
        modifierAuthType: (0, expect_1.default)(context.authType),
        modifierCasualName: await (0, unwrap_1.default)((_a = context.auth) === null || _a === void 0 ? void 0 : _a.uid, async (uid) => (0, BaseUser_1.baseUserCasualName)(await (0, User_1.userRead)(uid, database))),
        modifierId: (_b = context.auth) === null || _b === void 0 ? void 0 : _b.uid,
        object,
        objectId,
    };
};
exports.objectLogForHook = objectLogForHook;
